import { ReorderConflictReviewScreen } from '../../../screens';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return <ReorderConflictReviewScreen />;
}
